import React from "react";
import { Aside } from "sprint-common-web";

import { EditLibraryAsideContent } from "./EditLibraryAsideContent";

export interface EditLibraryAsideProps {
    fileRecordId: string;
    isOpen: boolean;
    onCancel(): void;
    onSubmit(): void;
}

export const EditLibraryAside: React.FC<EditLibraryAsideProps> = (props: EditLibraryAsideProps) => {
    const { fileRecordId, isOpen, onSubmit, onCancel } = props;

    return (
        <Aside type="form" headerText="Edit library" isOpen={isOpen} onDismiss={onCancel} isLightDismiss={true}>
            <EditLibraryAsideContent fileRecordId={fileRecordId} onCancel={onCancel} onSubmit={onSubmit} />
        </Aside>
    );
};
